import { Button, IconButton, Paper, Slide, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { withUsuario } from '../../contexts/UsuarioContext';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import FolderOpen from '@material-ui/icons/FolderOpen';
import React from 'react';
import { Link } from 'react-router-dom';
import SaudeCaixaApi from '../../api/SaudeCaixaApi';
import DialogErrosValidacao from '../share/DialogErrosValidacao';
import LinearProgressBlockScreen from '../share/LinearProgressBlockScreen';
import VariantSnackbar from '../share/VariantSnackbar';

const styles = theme => ({
  root: {
    paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      [theme.breakpoints.up('sm')]: {
        paddingLeft: theme.spacing(3),
        paddingRight: theme.spacing(3),
      },
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
  button: {
    margin: theme.spacing(1),
  },
  divPrincipal: {
    width: '100%',
    display: 'table'
  },
  divSelecaoArquivo: {
    width: '1200px',
    display: 'table-cell'
  },
  divBotoes: {
    display: 'table-cell'
  },
  typography: {
    display: 'inline',
    margin: theme.spacing(2),
  },
  centralizado: {
    textAlign: 'center'
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  link: {
    textDecoration: 'none',
  },
  titlebar: {
    display: 'flex',
    alignItems: 'center',
  },
});
class EnvioArquivoFaturamento extends React.Component {
  arquivoCaixaApi = new SaudeCaixaApi();
  state= {
    nomeArquivo: '',
    arquivo: {},
    snackOpen: false,
    snackMessage: '',
    snackSucesso: false,
    openDialog: false,
    errosDialog: [],
    titleDialog: '',
    fetching: false,
    arquivoEnviado: false,
    enviarDisabled: true,
  }
  handleFileClick = () => {
    document.getElementById('contained-button-file').value = '';
  }

  handleFileSelection = files => {
    this.setState({nomeArquivo: files[0].name});
    var fileReader = new FileReader();
    var text = '';
    var arquivo = {
      conteudo: '',
      nome: '',
      tipo: ''
    };
    fileReader.onload = function (event) {
      text = event.target.result;
      arquivo.conteudo = text;
    };
    fileReader.onerror = function (event) {
      this.setState({snackOpen: true, snackMessage: 'Não foi possível ler o arquivo! Código do erro:' + event.target.error.code, snackSucesso: false});
    };

    // fileReader.readAsText(files[0], 'ISO-8859-1');
    fileReader.readAsText(files[0], 'UTF-8');
    arquivo.nome = files[0].name;
    arquivo.tipo = files[0].type;
    this.setState({arquivo: arquivo, nomeArquivo: arquivo.nome, enviarDisabled: false});
  };
  handleCloseSnackbar = () => {
    this.setState({ snackOpen: false });
  };
  handleClickEnviar = async () => {
    this.setState({fetching: true});
    this.validarArquivo();
  };
  validarArquivo = async () => {
    var result = await this.arquivoCaixaApi.validarArquivo(this.state.arquivo);
    if (result.data.codigoRetorno === 1) {
      this.enviarArquivo();
    } else {
      this.setState({openDialog: true, dialogContent: result.data.registrosComErros, dialogTitle: result.data.msgRetornoResumida, arquivoValido: false, fetching: false, enviarDisabled: true});
    }
  }
  enviarArquivo = async () => {
    var result = await this.arquivoCaixaApi.enviarArquivo(this.state.arquivo);

    if (result !== undefined){
      if (result.data.codigoRetorno === 1) {
        this.setState({snackOpen: true, snackMessage: result.data.msgRetornoResumida, arquivoValido: true, nomeArquivo: this.state.arquivo.nome, enviarDisabled: false, snackSucesso: true});
      } else {
        this.setState({openDialog: true, dialogContent: result.data.registrosComErros, dialogTitle: result.data.msgRetornoResumida, arquivoValido: false, enviarDisabled: true, fetching: false});
      }  
    } else {
      this.setState({snackOpen: true, snackMessage: 'Ocorreu um erro inesperado...', arquivoValido: false, nomeArquivo: '', enviarDisabled: true, snackSucesso: false});
    }
    this.setState({fetching: false, enviarDisabled: true, nomeArquivo: ''});
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
    event.preventDefault();
  };
  render () {
    const { classes } = this.props;
    const { nomeArquivo, fetching, arquivoEnviado } = this.state;
    const path = this.props.previousPath;

    return (
      <React.Fragment>
        <Link to={path} className={classes.link}>
          <Slide direction='down' timeout={600} in>
            <Paper elevation={1} className={classes.titlebar}>
              <IconButton color='inherit' aria-label='Close'>
                <ChevronLeft />
              </IconButton>
              <Typography variant='h5'>Envio de Arquivos Texto de Faturamento</Typography>
            </Paper>
          </Slide>
        </Link>
        {fetching ? <LinearProgressBlockScreen /> : null}
        <Paper className={classes.root} elevation={1}>
          <div className={classes.divPrincipal}>
            <div className={classes.divSelecaoArquivo}>
              <input
                style={{display: 'none'}}
                accept='.txt'
                className={classes.input}
                id='contained-button-file'
                multiple
                type='file'
                onChange={(e) => this.handleFileSelection(e.target.files)}
                onClick={this.handleFileClick}
              />
              <label htmlFor='contained-button-file'>
                <Button
                  color='primary'
                  variant='contained'
                  component='span'
                  className={classes.button}>
                  <FolderOpen className={classes.button} />
                  Selecione um arquivo
                </Button>
              </label>
              {nomeArquivo &&
              <Typography className={classes.typography}>
                {nomeArquivo}
              </Typography>}
            </div>
            <div className={classes.divBotoes}>
              <Button
                disabled={arquivoEnviado || nomeArquivo === ''}
                color='primary'
                variant='outlined'
                className={classes.button}
                onClick={this.handleClickEnviar}>
                Enviar
              </Button>
            </div>
          </div>
        </Paper>
        <VariantSnackbar
          vertical={'top'}
          horizontal={'right'}
          variant={this.state.snackSucesso ? 'success' : 'error'}
          message={this.state.snackMessage}
          open={this.state.snackOpen}
          handleClose={this.handleCloseSnackbar} />

        {this.state.openDialog &&
        <DialogErrosValidacao
          open={this.state.openDialog}
          handleClose={this.handleCloseDialog}
          erros={this.state.dialogContent}
          titulo={this.state.dialogTitle}
        />}
      </React.Fragment>
    );
  }
}

export default withUsuario((withStyles(styles)(EnvioArquivoFaturamento)));
